export default __webpack_public_path__ + "static/media/vivabonito0.95b9f636.jpg";